export const actionTypes = {
  DEVICE_V2_RESPONSE: 'DEVICE_V2_RESPONSE',
};

const addDeviceResponse = ({ fingerprint, status }) => ({
  type: actionTypes.DEVICE_V2_RESPONSE,
  fingerprint,
  status,
});

export { addDeviceResponse };
